module.exports = __webpack_public_path__ + "img/autocisterna.4d8bb31e.png";